import { API_TOKEN } from '@/environment'
import { getAccessToken, getSubdomain } from '@/service/activeSession'
import axios from 'axios'
import { applyAxiosErrorInterceptor } from './utils'

import * as env from '@/environment'

const createConnection = () => {
  const conn = axios.create({
    baseURL: env.FLOWISE_URL,
    headers: {
      'API-Token': API_TOKEN,
    },
  })
  return applyAxiosErrorInterceptor(conn)
}

const authHeaders = async () => {
  return {
    Authorization: `Bearer ${await getAccessToken()}`,
    subdomain: await getSubdomain(),
  }
}

/**
 * The Flowise endpoint returns a set of fragments.
 * The fragment that has `fragmentType: 'Response'` is the final and correct response.
 * There's a max limit to avoid it running forever.
 */

const findResponseFragment = (fragments) => {
  const MAX_FRAGMENTS = 100
  for (let i = 0; i < fragments.length && i < MAX_FRAGMENTS; i++) {
    if (fragments[i].fragmentType === 'Response') return fragments[i]
  }
  return {
    fragmentType: 'Noop',
    text: 'an error occured',
  }
}

const handleResponse = (res) => {
  const responseFragment = findResponseFragment(res.data)

  const result = {
    error: false,
    status: res.status,
    statusText: res.statusText,
    data: responseFragment,
    url: res.request?.responseURL,
    method: res.config?.method?.toUpperCase(),
  }
  return result
}

const handleError = (err) => {
  if (!err.response) {
    return {
      error: true,
      status: -1,
      statusText: 'Something went wrong',
      data: {},
      url: err.request?.responseURL,
      method: err.config?.method?.toUpperCase(),
    }
  }
  return {
    error: true,
    status: err.response.status,
    statusText: err.response.statusText,
    data: err.response.data,
    url: err.request?.responseURL,
    method: err.config?.method?.toUpperCase(),
  }
}

export default {
  connection: createConnection(),

  async getTranslationAi(text, targetLocale) {
    const question = `Translate text to ${targetLocale}. Do not include any explanation. text: ${text}`
    const payload = {
      question,
      flowId: env.FLOWISE_AI_API_KEY,
      stream: false,
      instance: env.APP_ENV,
    }
    try {
      const response = await this.connection.post('/api/flowise', payload, {
        headers: await authHeaders(),
      })
      return handleResponse(response)
    } catch (error) {
      return handleError(error)
    }
  },

  async getShortenAi(text, oldText) {
    const defaultQuestion = `Shorten text. Do not include any explanation. text: ${text}`
    const optionalQuestion = oldText
      ? `It should be different from this text: ${oldText}`
      : ''

    const question = `${defaultQuestion} ${optionalQuestion}`

    const payload = {
      question,
      flowId: env.FLOWISE_AI_API_KEY,
      stream: false,
      instance: env.APP_ENV,
    }
    try {
      const response = await this.connection.post('/api/flowise', payload, {
        headers: await authHeaders(),
      })
      return handleResponse(response)
    } catch (error) {
      return handleError(error)
    }
  },
}
